import { useClassroom } from '../../state/Classroom';
import { languageName } from '../../lib/types';
import { JoinForm } from '../Home';

export default function MyClasses() {
  const { classrooms, active, setActiveId } = useClassroom();
  return (
    <div className="narrow">
      <h1>My class</h1>
      <p className="sub">You can be in more than one class. Switch between them here.</p>
      <div className="list" style={{ marginBottom: 28 }}>
        {classrooms.map(c => (
          <div key={c.id} className="item">
            <span className="grow">
              <span className="term">{c.name}</span>
              <span className="gloss small">{languageName(c.language)}</span>
            </span>
            {c.id === active?.id
              ? <span className="status done">Open</span>
              : <button className="small" onClick={() => setActiveId(c.id)}>Open</button>}
          </div>
        ))}
      </div>
      <h2>Join another class</h2>
      <JoinForm />
    </div>
  );
}
